import { createContext, ReactNode, useEffect, useState } from "react";
import { TickerProps } from "../../types";
import testData from "./testTickers.json";

export const TickersContext = createContext<{
  tickers: TickerProps[];
}>({
  tickers: [],
});

export const TickersProvider = ({ children }: { children: ReactNode }) => {
  const mode = process.env.REACT_APP_MODE || "PROD";
  const initialTickers: TickerProps[] = mode === "PROD" ? [] : testData;

  const [tickers, setTickers] = useState<TickerProps[]>(initialTickers);

  useEffect(() => {
    const tickerEventListener = (event: MessageEvent) => {
      if (event.origin === window.location.origin) {
        const { type } = event.data;
        if (type === "auth") {
          fetchTickers();
        }
      }
    };

    const fetchTickers = async () => {
      const response = await fetch("https://api.algotron.io/api/tickers", {
        credentials: "include"
      });
      const data = await response.json();

      if (data.status === "error") return console.error(data.message);

      if (mode !== "TEST") setTickers(data.data);
    };

    fetchTickers();
    window.addEventListener("message", tickerEventListener);

    return () => {
      window.removeEventListener("message", tickerEventListener);
    };
  }, [mode]);

  return (
    <TickersContext.Provider value={{ tickers }}>
      {children}
    </TickersContext.Provider>
  );
};
